"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventBody = /** @class */ (function () {
    function EventBody(eventBody) {
        this.json = {};
        this.json = eventBody || {};
    }
    EventBody.prototype.getJson = function () {
        return this.json;
    };
    EventBody.prototype.AddParam = function (name, value) {
        if (!this.json) {
            this.json = {};
        }
        this.json[name] = value;
        return this;
    };
    return EventBody;
}());
exports.default = EventBody;
//# sourceMappingURL=eventbody.js.map